import { render, staticRenderFns } from "./FormTagsBasic.vue?vue&type=template&id=78577224&"
import script from "./FormTagsBasic.vue?vue&type=script&lang=js&"
export * from "./FormTagsBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports